//Call_[npm_run_updateIndexes]_to_update_this_file.

// @create-index

import _doingGet_application_swagger from './doingGet_application_swagger';
export const doingGet_application_swagger = _doingGet_application_swagger;
export default {doingGet_application_swagger};

